<style lang="scss" scoped>
.head {
  width: 1200px;
  position: fixed;
  padding-top: 10px;
  top: 0;
  z-index: 9;
  margin: 0 auto;
  background: #fff;
  text-align: center;
  .image {
    width: 700px;
  }
}
</style>
<template>
  <div class="head">
    <el-steps
      :active="active"
      align-center
    >
      <el-step title="关联云店小程序" />
      <el-step title="代开发授权添加" />      
    </el-steps>
  </div>
</template>
<script>
export default {
  name: 'FormHead',
  props: {},
  data () {
    return {
      active: 1
    }
  },
  watch: {},
  mounted () {
    console.log('this.$route', this.$route)
    this.getPath()
  },
  updated () {
    // this.getPath()
  },
  methods: {
    getPath () {
      const paths = {
        '/qwAuth/createdApp': 1,
        '/qwAuth/configApp': 2,
        '/qwAuth/createdContacts': 3
      }
      this.active = paths[this.$route.fullPath]
      console.log('this.active', this.active, paths[this.$route.fullPath])
    }
  }
}
</script>
